module.exports = __webpack_public_path__ + "zvetseni-rtu-permalip_2_after.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/plasticka-chirurgie/zvetseni-rtu-permalip_2_after.jpg
// module id = 1375
// module chunks = 0